// Segments form paths

export const EDIT_SEGMENT_PATH =
	'/panel/vod/:vodId/materials/:videoId/segment/:segmentId/edit';
export const CREATE_SEGMENT_PATH =
	'/panel/vod/:vodId/materials/:videoId/segment/create';
